import { render, staticRenderFns } from "./TechnicalStaffList.vue?vue&type=template&id=d184b4f0&"
import script from "./TechnicalStaffList.vue?vue&type=script&lang=js&"
export * from "./TechnicalStaffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports